/*
 * @Author: WangChao
 * @Date: 2026-02-05 19:37:23
 * @LastEditors: WangChao
 * @LastEditTime: 2026-08-13 15:45:18
 * @FilePath: \travel_ai\src\router\index.js
 * @Description:
 */
import Vue from "vue";
import Router from "vue-router";
import { internalStore } from "../utils/LLM/localStore";

Vue.use(Router);
const routes = [
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("@/components/layout/index")
  },
  {
    path: "/ssoLogin",
    name: "SSOLogin",
    component: () => import("@/components/layout/login")
  },
  {
    path: "/chat",
    name: "chat",
    component: () => import("@/components/layout/chat"),
    meta: { title: { en: "chat", "zh-CN": "商旅助手" }, requiresAuth: true }
  },
  {
    path: "/flight-order",
    name: "flightOrder",
    component: () => import("@/components/layout/flight/flight-order"),
    meta: {
      title: { en: "flight order", "zh-CN": "机票预订" },
      requiresAuth: true
    }
  },
  {
    path: "/flightList",
    name: "flightList",
    component: () => import("@/components/layout/flight/flightList"),
    meta: {
      title: { en: "flight list", "zh-CN": "航班列表" },
      requiresAuth: true
    }
  },
  {
    path: "/hotelDetail",
    name: "hotelDetail",
    component: () => import("@/components/layout/hotel/hotelDetail"),
    meta: {
      title: { en: "hotel Detail", "zh-CN": "酒店详情" },
      requiresAuth: true
    }
  },
  {
    path: "/trainList",
    name: "trainList",
    component: () => import("@/components/layout/train/train-list"),
    meta: {
      title: { en: "train list", "zh-CN": "火车推荐" },
      requiresAuth: true
    }
  },
  {
    path: "/mixList",
    name: "mixList",
    component: () => import("@/components/layout/mixRecommend/mix-list"),
    meta: {
      title: { en: "mix list", "zh-CN": "混合推荐" },
      requiresAuth: true
    }
  },
  {
    path: "/login12306",
    name: "trainLogin",
    component: () => import("@/components/layout/train/login"),
    meta: {
      title: { en: "train login", "zh-CN": "登录12306账号" },
      requiresAuth: true
    }
  },
  {
    path: "/smsVerification",
    name: "smsVerification",
    component: () => import("@/components/layout/train/smsVerification"),
    meta: {
      title: { en: "sms verification", "zh-CN": "短信核验页面" },
      requiresAuth: true
    }
  },
  {
    path: "/trainIframeFaceID",
    name: "trainIframeFaceID",
    component: () => import("@/components/layout/train/trainIframeFaceID"),
    meta: {
      title: { en: "train iframe faceID", "zh-CN": "人脸视频核验身份" },
      requiresAuth: true
    }
  },
  {
    path: "/trainFaceID",
    name: "faceID12306",
    component: () => import("@/components/layout/train/trainFaceID"),
    meta: {
      title: { en: "train faceID", "zh-CN": "人脸识别核验结果" },
      requiresAuth: true
    }
  }
];

const router = new Router({ routes });

// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = internalStore.get("loginData");

  if (to.meta.requiresAuth && !token) {
    next("/"); // 需要验证但无token，重定向到登录页
  } else {
    next(); // 正常进入
  }
});

export default router;
